import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    AdreseCentre,
    AdreseCentreAddPayload, AdreseCentreEditPayload,
} from './adrese-centre.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AdreseCentreService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.adreseCentre.list;

    public listDTUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.adreseCentre.listDT;

    private storeURL =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.adreseCentre.store;

    private updateUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.adreseCentre.update;

    private deleteUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.adreseCentre.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.adreseCentre
            .listActive;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.adreseCentre
            .active;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getList() {
        return this.http.get(this.listUrl, this.httpOptions);
    }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    storeEntry(payload: AdreseCentreAddPayload) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: AdreseCentreEditPayload) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
